import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const card = tv({
	slots: {
		base: 'p-2 md:p-3 w-full rounded-l',
		titleText: 'mb-1 uppercase',
		bodyText: '',
		button: 'mt-1 md:mt-2 w-fit',
	},
	variants: {
		theme: {
			primary: {
				base: 'bg-mainPink lg:max-w-[45rem]',
				titleText: 'text-white',
				bodyText: 'text-black',
			},
			secondary: {
				base: 'bg-black lg:max-w-[45rem]',
				titleText: 'text-mainPink',
				bodyText: 'text-white',
			},
			ternary: {
				base: 'bg-white flex flex-col',
				titleText: 'text-black',
				bodyText: 'text-black',
			},
		},
	},
})

export type CardVariants = VariantProps<typeof card>
